import type { CountryData, SettingsData } from "~/types"

export const useSettingsStore = defineStore('settings', () => {
  const settings = ref<SettingsData[]>([])
  const countries = ref<CountryData[]>([])

  const setSettings = (data?: SettingsData[]) => {
    settings.value = Array.isArray(data) ? data : []
  }

  const setCountries = (data?: CountryData[]) => {
    countries.value = Array.isArray(data) ? data : []
  }

  const fetchSetting = async () => {
    try {
      const { data, error } = await useApiFetch('/api/setting-public', {
        server: true, // allow SSR
        key: 'setting-public',
      })
      if (error.value) throw error.value
      setSettings(data.value?.data || [])
    } catch (err) {
      console.error('fetchSetting error:', err)
      setSettings([]) // fallback
    }
  }

  const fetchCountries = async () => {
    try {
      const { data, error } = await useApiFetch('/api/country-public-list', {
        server: true, // allow SSR
        key: 'country-public',
      })
      if (error.value) throw error.value
      setCountries(data.value?.data || [])
    } catch (err) {
      console.error('fetchCountries error:', err)
      setCountries([]) // fallback
    }
  }

  return {
    settings,
    countries,
    setSettings,
    setCountries,
    fetchSetting,
    fetchCountries,
  }
})
